export const roleTitle = [
    {value: 2, label: "KTV"},
    {value: 3, label: "Lễ tân"},
    {value: 5, label: "Sale online"},
    {value: 4, label: "Cổ đông"},
  ]